var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4773 9.25117L25.746 21.8663C25.906 22.2428 25.976 22.549 25.996 22.8671C26.036 23.6103 25.776 24.3326 25.2661 24.8885C24.7562 25.4424 24.0663 25.7694 23.3164 25.8091H8.6789C8.36896 25.7903 8.05901 25.7199 7.76906 25.6109C6.3193 25.0263 5.61942 23.3814 6.20932 21.9555L13.5281 9.24225C13.778 8.79536 14.158 8.4099 14.6279 8.16218C15.9877 7.4081 17.7174 7.90355 18.4773 9.25117ZM16.8675 17.5648C16.8675 18.0404 16.4776 18.4378 15.9977 18.4378C15.5178 18.4378 15.1178 18.0404 15.1178 17.5648V14.7616C15.1178 14.2849 15.5178 13.8995 15.9977 13.8995C16.4776 13.8995 16.8675 14.2849 16.8675 14.7616V17.5648ZM15.9977 21.8267C15.5178 21.8267 15.1178 21.4293 15.1178 20.9547C15.1178 20.4781 15.5178 20.0817 15.9977 20.0817C16.4776 20.0817 16.8675 20.4691 16.8675 20.9438C16.8675 21.4293 16.4776 21.8267 15.9977 21.8267Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.9f4d63961072630714c41ad584532834.svg";
export { ForwardRef as ReactComponent };